import { Event, EventType } from "./Event";

import type { IAddPageVisitEvent } from "./types";

export class AddPageVisitEvent extends Event {
  constructor({ tracking, customEventProperties }: IAddPageVisitEvent) {
    super({
      event_type: EventType.page_visit,
      event_properties: {
        tracking,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
